"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutMutation = void 0;
const client_1 = require("@apollo/client");
exports.logoutMutation = client_1.gql `
  mutation Logout {
    logout {
      __typename
      ok
    }
  }
`;
//# sourceMappingURL=logout.js.map